module.exports = __webpack_public_path__ + "static/flags/JM-e5b85db9bf2d623810b3e5cec9323835.gif";